<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Danh sách học sinh" :link="[{ text: 'Học sinh', href: '../students' }]" />
      </div>
      <div class="d-flex flex-wrap justify-end flex-gap">
        <v-btn v-if="$vuetify.breakpoint.mdAndUp" outlined color="success" @click="exportExcel">
          <v-icon left>mdi-file-excel</v-icon> Xuất Excel
        </v-btn>
        <v-btn
          v-if="$vuetify.breakpoint.mdAndUp && $auth.policies['add-new-student'] && isShowAddExcel"
          class="ml-6"
          color="#0D47A1"
          dark
          outlined
          depressed
          @click.stop="showExcelDialog = !showExcelDialog"
        >
          <v-icon left>add</v-icon> Thêm HS theo file excel
        </v-btn>
        <v-btn
          v-if="$auth.policies['add-new-student']"
          class="ml-6"
          dark
          depressed
          color="#0D47A1"
          @click.stop="createState = !createState"
        >
          <v-icon left>add</v-icon>{{ btnTitle }}
        </v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ml-2" v-bind="attrs" v-on="on" icon>
              <v-icon color="primary">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title style="cursor: pointer" @click="openUpdateStudentAvatarDialog">
                Cập nhật ảnh học sinh
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <StudentFilter ref="student-filter" @onFilterChanged="filterStudent" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <StudentDataTable ref="student-data-table" />
    </v-card>

    <UpdateAvatarDialog ref="update-avatar-dialog" />
    <AddStudentDialog :state="createState" @done="studentAdded" />
    <AddStudentByExcelDialog :state="showExcelDialog" />
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import StudentFilter from './components/StudentFilter.vue'
import StudentDataTable from './components/StudentDataTable.vue'
import AddStudentDialog from './components/AddStudentDialog'
import UpdateAvatarDialog from '@/views/student/components/UpdateAvatarDialog'
import utils from '@/plugins/utils'
import { mapActions } from 'vuex'

export default {
  components: {
    Breadcrumbs,
    StudentFilter,
    StudentDataTable,
    UpdateAvatarDialog,
    AddStudentDialog,
    AddStudentByExcelDialog: () => import('./components/AddStudentByExcelDialog.vue')
  },
  data() {
    return {
      isShowAddExcel: true,
      createState: false,
      showExcelDialog: false,
      studentFilters: { status: 'active' }
    }
  },
  computed: {
    btnTitle() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 'Thêm'
      } else {
        return 'Thêm học sinh'
      }
    }
  },
  methods: {
    ...mapActions('students', ['getAllStudents']),
    openUpdateStudentAvatarDialog() {
      this.$refs['update-avatar-dialog'].openDialog()
    },
    filterStudent(query) {
      this.studentFilters = { ...query }
      this.$refs['student-data-table'].searchStudents(query)
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        let headers = [...this.$refs['student-data-table'].headers]
        headers.splice(1, 0, {
          text: 'Mã số',
          value: 'code'
        })
        const excelHeader = headers
          .map(({ text, value }) => ({ text, value }))
          .filter(excel => excel.value !== 'action')
        const filters = this.$refs['student-data-table'].$options.filters
        const list = await this.getAllStudents({ searchParams: { ...this.studentFilters, _limit: -1, _sort: 'nameToNumber:ASC,index:ASC' }, disableSave: true })
        const students = JSON.parse(JSON.stringify(list))
        const data = students.map(item => {
          item.code = item.code
          item.status = filters.getStatus(item.status)
          item.currentClass = filters.getCurrentClass(item.currentClass)
          item.gender = filters.gender(item.gender)
          item.dob = filters.ddmmyyyy(item.dob)
          return item
        })
        utils.exportExcel(data, excelHeader, 'DanhSachHocSinh')
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
    studentAdded(student) {
      const code = this.$options.filters.getStudentCode(student.code)
      this.$refs['student-filter'].studentCode = code
      this.$refs['student-filter'].studentName = student.name
      this.$refs['student-filter'].onFilterChanged()
    }
  }
}
</script>
<style scoped>
td {
  white-space: nowrap !important;
}
.flex-gap {
  row-gap: 24px;
}
</style>
